function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return !!right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * TinyGesture.js
 *
 * This service uses passive listeners, so you can't call event.preventDefault()
 * on any of the events.
 *
 * Adapted from https://gist.github.com/SleepWalker/da5636b1abcbaff48c4d
 * and https://github.com/uxitten/xwiper
 */
var TinyGesture = /*#__PURE__*/function () {
	function TinyGesture(element, options) {
		_classCallCheck(this, TinyGesture);

		options = Object.assign({}, TinyGesture.defaults, options);
		this.element = element;
		this.opts = options;
		this.touchStartX = null;
		this.touchStartY = null;
		this.touchEndX = null;
		this.touchEndY = null;
		this.velocityX = null;
		this.velocityY = null;
		this.longPressTimer = null;
		this.doubleTapWaiting = false;
		this.handlers = {
			'panstart': [],
			'panmove': [],
			'panend': [],
			'swipeleft': [],
			'swiperight': [],
			'swipeup': [],
			'swipedown': [],
			'tap': [],
			'doubletap': [],
			'longpress': []
		};
		this._onTouchStart = this.onTouchStart.bind(this);
		this._onTouchMove = this.onTouchMove.bind(this);
		this._onTouchEnd = this.onTouchEnd.bind(this);
		this.element.addEventListener('touchstart', this._onTouchStart, passiveIfSupported);
		this.element.addEventListener('touchmove', this._onTouchMove, passiveIfSupported);
		this.element.addEventListener('touchend', this._onTouchEnd, passiveIfSupported);

		if (this.opts.mouseSupport && !('ontouchstart' in window)) {
			this.element.addEventListener('mousedown', this._onTouchStart, passiveIfSupported);
			document.addEventListener('mousemove', this._onTouchMove, passiveIfSupported);
			document.addEventListener('mouseup', this._onTouchEnd, passiveIfSupported);
		}
	}

	_createClass(TinyGesture, [{
		key: "destroy",
		value: function destroy() {
			this.element.removeEventListener('touchstart', this._onTouchStart);
			this.element.removeEventListener('touchmove', this._onTouchMove);
			this.element.removeEventListener('touchend', this._onTouchEnd);
			this.element.removeEventListener('mousedown', this._onTouchStart);
			document.removeEventListener('mousemove', this._onTouchMove);
			document.removeEventListener('mouseup', this._onTouchEnd);
			clearTimeout(this.longPressTimer);
			clearTimeout(this.doubleTapTimer);
		}
	}, {
		key: "on",
		value: function on(type, fn) {
			var _this = this;

			if (this.handlers[type]) {
				this.handlers[type].push(fn);
				return {
					type: type,
					fn: fn,
					cancel: function cancel() {
						return _this.off(type, fn);
					}
				};
			}
		}
	}, {
		key: "off",
		value: function off(type, fn) {
			if (this.handlers[type]) {
				var idx = this.handlers[type].indexOf(fn);

				if (idx !== -1) {
					this.handlers[type].splice(idx, 1);
				}
			}
		}
	}, {
		key: "fire",
		value: function fire(type, event) {
			for (var i = 0; i < this.handlers[type].length; i++) {
				this.handlers[type][i](event);
			}
		}
	}, {
		key: "onTouchStart",
		value: function onTouchStart(event) {
			var _this2 = this;

			this.thresholdX = this.opts.threshold('x', this);
			this.thresholdY = this.opts.threshold('y', this);
			this.disregardVelocityThresholdX = this.opts.disregardVelocityThreshold('x', this);
			this.disregardVelocityThresholdY = this.opts.disregardVelocityThreshold('y', this);
			this.touchStartX = event.type === 'mousedown' ? event.screenX : event.changedTouches[0].screenX;
			this.touchStartY = event.type === 'mousedown' ? event.screenY : event.changedTouches[0].screenY;
			this.touchMoveX = null;
			this.touchMoveY = null;
			this.touchEndX = null;
			this.touchEndY = null; // Long press.

			this.longPressTimer = setTimeout(function () {
				return _this2.fire('longpress', event);
			}, this.opts.longPressTime);
			this.fire('panstart', event);
		}
	}, {
		key: "onTouchMove",
		value: function onTouchMove(event) {
			if (event.type === 'mousemove' && (!this.touchStartX || this.touchEndX !== null)) {
				return;
			}

			var touchMoveX = (event.type === 'mousemove' ? event.screenX : event.changedTouches[0].screenX) - this.touchStartX;
			this.velocityX = touchMoveX - this.touchMoveX;
			this.touchMoveX = touchMoveX;
			var touchMoveY = (event.type === 'mousemove' ? event.screenY : event.changedTouches[0].screenY) - this.touchStartY;
			this.velocityY = touchMoveY - this.touchMoveY;
			this.touchMoveY = touchMoveY;
			var absTouchMoveX = Math.abs(this.touchMoveX);
			var absTouchMoveY = Math.abs(this.touchMoveY);
			this.swipingHorizontal = absTouchMoveX > this.thresholdX;
			this.swipingVertical = absTouchMoveY > this.thresholdY;
			this.swipingDirection = absTouchMoveX > absTouchMoveY ? this.swipingHorizontal ? 'horizontal' : 'pre-horizontal' : this.swipingVertical ? 'vertical' : 'pre-vertical';

			if (Math.max(absTouchMoveX, absTouchMoveY) > this.opts.pressThreshold) {
				clearTimeout(this.longPressTimer);
			}

			this.fire('panmove', event);
		}
	}, {
		key: "onTouchEnd",
		value: function onTouchEnd(event) {
			var _this3 = this;

			if (event.type === 'mouseup' && (!this.touchStartX || this.touchEndX !== null)) {
				return;
			}

			this.touchEndX = event.type === 'mouseup' ? event.screenX : event.changedTouches[0].screenX;
			this.touchEndY = event.type === 'mouseup' ? event.screenY : event.changedTouches[0].screenY;
			this.fire('panend', event);
			clearTimeout(this.longPressTimer);
			var x = this.touchEndX - this.touchStartX;
			var absX = Math.abs(x);
			var y = this.touchEndY - this.touchStartY;
			var absY = Math.abs(y);

			if (absX > this.thresholdX || absY > this.thresholdY) {
				this.swipedHorizontal = this.opts.diagonalSwipes ? Math.abs(x / y) <= this.opts.diagonalLimit : absX >= absY && absX > this.thresholdX;
				this.swipedVertical = this.opts.diagonalSwipes ? Math.abs(y / x) <= this.opts.diagonalLimit : absY > absX && absY > this.thresholdY;

				if (this.swipedHorizontal) {
					if (x < 0) {
						// Left swipe.
						if (this.velocityX < -this.opts.velocityThreshold || x < -this.disregardVelocityThresholdX) {
							this.fire('swipeleft', event);
						}
					} else {
						// Right swipe.
						if (this.velocityX > this.opts.velocityThreshold || x > this.disregardVelocityThresholdX) {
							this.fire('swiperight', event);
						}
					}
				}

				if (this.swipedVertical) {
					if (y < 0) {
						// Upward swipe.
						if (this.velocityY < -this.opts.velocityThreshold || y < -this.disregardVelocityThresholdY) {
							this.fire('swipeup', event);
						}
					} else {
						// Downward swipe.
						if (this.velocityY > this.opts.velocityThreshold || y > this.disregardVelocityThresholdY) {
							this.fire('swipedown', event);
						}
					}
				}
			} else if (absX < this.opts.pressThreshold && absY < this.opts.pressThreshold) {
				// Tap.
				if (this.doubleTapWaiting) {
					this.doubleTapWaiting = false;
					clearTimeout(this.doubleTapTimer);
					this.fire('doubletap', event);
				} else {
					this.doubleTapWaiting = true;
					this.doubleTapTimer = setTimeout(function () {
						return _this3.doubleTapWaiting = false;
					}, this.opts.doubleTapTime);
					this.fire('tap', event);
				}
			}
		}
	}]);

	return TinyGesture;
}();

TinyGesture.defaults = {
	threshold: function threshold(type, self) {
		return Math.max(25, Math.floor(0.15 * (type === 'x' ? window.innerWidth || document.body.clientWidth : window.innerHeight || document.body.clientHeight)));
	},
	velocityThreshold: 10,
	disregardVelocityThreshold: function disregardVelocityThreshold(type, self) {
		return Math.floor(0.5 * (type === 'x' ? self.element.clientWidth : self.element.clientHeight));
	},
	pressThreshold: 8,
	diagonalSwipes: false,
	diagonalLimit: Math.tan(45 * 1.5 / 180 * Math.PI),
	longPressTime: 500,
	doubleTapTime: 300,
	mouseSupport: true
}; // Passive feature detection.

var passiveIfSupported = false;

try {
	window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
		get: function get() {
			passiveIfSupported = {
				passive: true
			};
		}
	}));
} catch (err) { }

/*

	Gibe Gallery
	v1.0

	DEPENDENCIES
	------------

	Mustache (https://github.com/janl/mustache.js/)

	OPTIONAL EXTRAS
	---------------

	TinyGesture (https://github.com/sciactive/tinygesture)
	Body scroll lock (https://github.com/willmcpo/body-scroll-lock)

	USAGE
	-----

	$('[data-your-selector]').gibeGallery({
		launch: 769,
		links: 'a',
		linksActiveClass: 'active',
		stage: '[data-gibe-gallery-stage]',
		templates: {
			overlay: '#gibeGalleryOverlayTemplate'
		},
		horizontal: {
			width: 1000,
			height: 800
		},
		forceSquare: false,
		fadeTime: 500,
		hoverTime: 150,
		maxWidth: 1400
	});

	SETTINGS
	--------

	launch: int (minimum browser width the gallery should launch at; 769)
	links: string (selector for gallery links; 'a')
	linksActiveClass: string (the class to add for the active inline thumbnail; '')
	templates: object (selector for gallery templates; { overlay: '#gibeGalleryOverlayTemplate' })
	horizontal: object (minimum window width and height in which to render the horizontal gallery layout; { width: 1000, height: 800 })
	forceSquare: bool (whether or not to force gallery items to always fill a square area; false)
	fadeTime: int (fade time in ms; 500 - this should match that set in the SASS file for this plugin)
	hoverTime: int (hover time on thumb before preloading; 150)
	maxWidth: int (maximum width of the gallery; 1400)
	onStageChange: function (callback when the stage changes; empty function)

*/

jQuery.fn.gibeGallery = function (overrides) {

	// Avoid scope issues by using 'base' instead of 'this'

	var base = this;

	// If the selector does not contain any elements, return the jQuery object

	if (!base.length) return base;

	// Cache selector

	base.element = $(base);

	// Add a reverse reference to the DOM object

	base.element.data('gibeGallery', base);

	// Define default settings

	base.settings = new Object();
	base.settings.launch = 769;
	base.settings.links = 'a:not(.js-not-gallery)';
	base.settings.linksActiveClass = '';
	base.settings.quicklinks = '[data-gibe-quick-link]';
	base.settings.stage = '[data-gibe-gallery-stage]';
	base.settings.templates = {
		overlay: '#gibeGalleryOverlayTemplate'
	};
	base.settings.horizontal = {
		width: 1000,
		height: 800
	};
	base.settings.forceSquare = false;
	base.settings.transition = "fade";
	base.settings.fadeTime = 500;
	base.settings.hoverTime = 150;
	base.settings.maxWidth = 1400;
	base.settings.onStageChange = function (index) { };

	// Use overriding settings if supplied

	if (overrides !== undefined) base.settings = $.extend({}, base.settings, overrides);

	base.settings.fadeTime = base.settings.transition === "slide" ? 0 : base.settings.fadeTime;

	// Add flags to indicate touchswipe, object fit and touch support

	base.settings.swipe = typeof TinyGesture !== 'undefined' ? true : false;
	base.settings.objectfit = 'objectFit' in document.documentElement.style;
	base.settings.touch = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;
	base.settings.scrollLock = typeof bodyScrollLock !== 'undefined' ? true : false;

	// Add flag to indicate whether or not we should force the gallery for all screen sizes (relevant when gallery launched from hidden zoom button for screen readers)

	base.settings.forceGallery = false;

	// Set the transition type
	if (base.settings.transition === "slide") {
		base.element.addClass('c-gallery--slide');
	}

	// Helper functions

	base.helpers = {

		getKeyPressed: function (e) {

			if (e.key !== undefined) return e.key; else if (e.keyIdentifier !== undefined) return e.keyIdentifier; else if (e.keyCode !== undefined) return e.keyCode;

		}

	};

	// Cache Mustache templates

	base.overlayTemplate = $(base.settings.templates.overlay).html();

	// Cache elements

	base.elements = {

		links: base.element.find(base.settings.links),
		quicklinks: base.element.find(base.settings.quicklinks),
		stage: base.element.find(base.settings.stage),
		doc: $(document),
		win: $(window),
		html: $('html'),
		body: $('body')

	};

	// Cache gallery title / subtitle

	base.title = base.element.attr('data-gibe-gallery-title') || false;
	base.subtitle = base.element.attr('data-gibe-gallery-subtitle') || false;

	// Create and populate array of gallery items

	base.items = [];

	base.threeSixtyInstances = [];
	base.threeSixtyHasInit = false;
	base.threeSixtyCache = [];

	base.userIsUsingButtons = false;

	base.tinyGestureOptions = {
		mouseSupport: false,
		threshold: function (type, self) {
			if (type === "x") {
				return 5;
			} else {
				return 200;
			}

		},
		velocityThreshold: 6
	};

	base.elements.links.each(function (index) {

		var target = $(this),
			img = target.find('img'),
			media = target.attr('href'),
			id = target.attr('data-gibe-gallery-item-id'),
			isImage = target.attr('data-gibe-gallery-item') === 'image' ? true : false,
			isVideo = target.attr('data-gibe-gallery-item') === 'video' ? true : false;
		is360 = target.attr('data-gibe-gallery-item') === '360' ? true : false;
		techImage = target.attr('data-gibe-gallery-item-techimage') && target.attr('data-gibe-gallery-item-techimage').toLowerCase() === "true" ? true : false;

		if (isVideo) media = target.attr('data-gibe-gallery-item-id');
		if (is360) media = target.attr('data-360-images');

		target.data('index', index);

		base.items.push({
			IsImage: isImage,
			IsVideo: isVideo,
			Is360: is360,
			StickyThumbnail: isVideo || is360 || techImage,
			Thumbnail: img.attr('src'),
			Id: id,
			Media: media,
			Title: 'Gallery item ' + (index + 1) + ' - ' + (target.attr('data-gibe-gallery-item-title') || target.attr('title') || img.attr('alt') || ''),
			AspectRatio: target.attr('data-gibe-gallery-item-aspect-ratio') || false,
			TechImage: techImage
		});

	});

	// Add flag to indicate multi slide

	base.settings.multiSlide = base.items.length > 1;

	// Add active class to first link

	base.elements.links.eq(0).addClass(base.settings.linksActiveClass);

	// Launch appropriate experience when thumbnails are clicked

	base.elements.links.on('click', function (e) {

		base.signalUserIsUsingButtons();

		// Cache index of element

		var index = $(this).data('index');

		// "Launch" the stage

		base.stage.launch(index);

		// focus on zoom

		if (!base.stage.thumbnails.hasThumbnailScroller()) {
			base.elements.stage.find('.js-gibe-gallery-stage__item--active .js-gibe-gallery-stage__item__zoom').focus();
		}

		return false;

	});

	base.elements.quicklinks.on('click', function (e) {

		var id = $(this).attr('data-gibe-gallery-jump-to');
		var index = base.element.find('[data-gibe-gallery-item-id="' + id + '"]').parent().index();

		// "Launch" the stage

		base.signalUserIsUsingButtons();

		base.stage.launch(index);

		return false;

	});

	// Remove namespaced events

	base.elements.doc.off('keyup.gibeGallery');
	base.elements.doc.off('keydown.gibeGallery');
	base.elements.doc.off('click.gibeGallery');

	// ESCAPE KEY
	// Close the overlay when user presses escape

	base.elements.doc.on('keyup.gibeGallery', function (e) {

		var keyPressed = base.helpers.getKeyPressed(e);
		if (keyPressed === 27 || keyPressed === 'Escape' || keyPressed === 'Esc') base.gallery.close();

	});

	base.signalUserIsUsingButtons = function () {
		base.userIsUsingButtons = true;
		setTimeout(() => {
			base.userIsUsingButtons = false;
		}, 300);
	};


	// FOCUS STYLES
	// Add flags to show and hide focus states based on user interaction

	base.focusStyles = {

		on: function () { base.elements.html.addClass('js-gibe-gallery-use-focus-styles'); },

		off: function () { base.elements.html.removeClass('js-gibe-gallery-use-focus-styles'); }

	};

	base.elements.doc.on('keydown.gibeGallery', function (e) {

		var keyPressed = base.helpers.getKeyPressed(e);
		if (keyPressed === 'Tab' || keyPressed === 9) base.focusStyles.on();

	});


	base.elements.doc.on('click.gibeGallery', function () { base.focusStyles.off(); });

	// TOUCH STYLES

	if (matchMedia('(hover: none)').matches) base.elements.html.addClass('js-gibe-gallery-use-touch-styles');

	// RESIZE EVENTS
	// Throttle window resize events so as to not crash the browser

	base.timer = null;

	base.elements.win.resize(function () {
		base.gallery.resize.start();
		if (base.timer) { window.clearTimeout(base.timer); }
		base.timer = window.setTimeout(function () {

			base.gallery.resize.end();
			base.stage.resize.end();
			base.gallery.init360s();
			base.stage.thumbnails.checkArrowDisplay();

		}, 500);
	});

	base.initImageZoom = function () {
		setTimeout(function () {
			var imagesToZoom = document.querySelectorAll('.js-image-zoom');
			for (var i = 0; i < imagesToZoom.length; i++) {
				new ImageZoom(imagesToZoom[i]);
			}
		}, 250);
	};

	// OVERLAY
	// The gallery overlay used on larger screens

	base.gallery = {

		// Video instances

		videoInstances: {},

		// Whether or not the gallery should be allowed

		allow: function () {

			if (base.settings.forceGallery) return true;

			return window.matchMedia('(min-width: ' + base.settings.launch + 'px)').matches;

		},

		// Get the current element

		getElement: function () {

			return $('.js-gibe-gallery-overlay');

		},

		lockout: {

			on: function () {

				if (base.settings.scrollLock) {

					var element = base.gallery.getElement();

					bodyScrollLock.disableBodyScroll(element, {
						reserveScrollBarGap: true
					});

				}

			},

			off: function () {

				if (base.settings.scrollLock) { bodyScrollLock.clearAllBodyScrollLocks(); }

			}

		},

		// Handle resizing of the gallery

		resize: {

			wide: function () {

				return window.matchMedia('(min-width: ' + base.settings.horizontal.width + 'px) and (min-height: ' + base.settings.horizontal.height + 'px)').matches;

			},

			calculate: {

				availableHeight: function (inner, content) {

					// Start with window height

					var availableHeight = base.elements.win.height();

					// Reduce by top and bottom padding around physical overlay (the dimmer)

					availableHeight -= parseInt(inner.css('padding-top'));
					availableHeight -= parseInt(inner.css('padding-bottom'));

					// Reduce by top and bottom padding around content inside the overlay

					availableHeight -= parseInt(content.css('padding-top'));
					availableHeight -= parseInt(content.css('padding-bottom'));

					return availableHeight;

				},

				galleryHeight: function (availableHeight, title) {

					// Reduce previously calculated available height by height of title (if it exists)

					if (!title.length) return availableHeight;

					return availableHeight - title.outerHeight();

				},

				thumbnailsHeight: function (availableHeight, close) {

					// Reduce previously calculated available height by height of close

					return availableHeight - (close.outerHeight() + 30);

				},

				secondaryWidth: function (thumbnailsHeight, thumbnailItems) {

					// Cache the height / width of first thumbnail (they are all the same) and the thumbnail count

					var thumbnailWidth = thumbnailItems.first().outerWidth() + 10;

					return thumbnailWidth;

				},

				thumbnailScrollerHeight: function (galleryHeight) {

					var height = 0;
					var stickyThumbnailListHeight = $('.js-gibe-gallery-overlay__thumbnails__list--sticky').height();
					var thumbnailsHeight = $('.js-gibe-gallery-overlay__thumbnails__list').first().height();
					var galleryMarginTop = parseInt($('.js-gibe-gallery-overlay__thumbnails').css('marginTop').replace('px', ''));

					if (thumbnailsHeight + stickyThumbnailListHeight < galleryHeight) {
						height = "auto";
					} else {
						height = Math.max(galleryHeight - $('.js-gibe-gallery-overlay__thumbnails__list--sticky').height() - galleryMarginTop, 110);
					}

					return height;
				},

				overrideHeight: function (galleryHeight, mainList, mainInner) {

					// If height of gallery is greater than width of main list, gallery height should be main list width (square)

					if (galleryHeight > mainList.width()) {

						// Start with width of main list

						galleryHeight = mainList.width();

						// Add padding from it's wrapper

						galleryHeight += parseInt(mainInner.css('padding-top'));
						galleryHeight += parseInt(mainInner.css('padding-bottom'));

					}

					return galleryHeight;

				},

				overrideWidth: function (galleryHeight, mainInner, secondary, content) {

					// Start with gallery height

					var contentWidth = galleryHeight;

					// Minus top and bottom padding on main inner

					contentWidth -= parseInt(mainInner.css('padding-top'));
					contentWidth -= parseInt(mainInner.css('padding-bottom'));

					// Add padding to left and right of main gallery

					contentWidth += parseInt(mainInner.css('padding-left'));
					contentWidth += parseInt(mainInner.css('padding-right'));

					// Add secondary width (containing the thumbs)

					contentWidth += parseInt(secondary.width());

					// Add left and right padding around content inside the overlay

					contentWidth += parseInt(content.css('padding-left'));
					contentWidth += parseInt(content.css('padding-right'));

					return Math.min(contentWidth, base.settings.maxWidth);

				}

			},

			// Method called when resizing begins

			start: function () {

				var element = base.gallery.getElement();

				if (!element.length) return;

				element.addClass('js-gibe-gallery-overlay--resizing');

			},

			// Method called when resizing ends

			end: function () {

				// Get gallery and return if not present

				var element = base.gallery.getElement();

				if (!element.length) return;

				// If resize event ends outside of gallery boundaries then close the gallery

				if (!base.gallery.allow()) {

					base.gallery.close();
					return;

				}

				// Cache required elements

				var inner = $('.js-gibe-gallery-overlay__inner__inner'),
					content = $('.js-gibe-gallery-overlay__content'),
					thumbnails = $('.js-gibe-gallery-overlay__thumbnails'),
					main = $('.js-gibe-gallery-overlay__main'),
					mainInner = $('.js-gibe-gallery-overlay__main__inner'),
					mainList = $('.js-gibe-gallery-overlay__main__list'),
					thumbnailItems = $('.js-gibe-gallery-overlay__thumbnails__item'),
					primary = $('.js-gibe-gallery-overlay__content__primary'),
					secondary = $('.js-gibe-gallery-overlay__content__secondary'),
					buttons = $('.js-gibe-gallery-overlay__main__button'),
					close = $('.js-gibe-gallery-overlay__close'),
					title = $('.js-gibe-gallery-overlay__title'),
					thumbnailsScroller = $('.js-gibe-gallery-overlay__thumbnails__list__scroller');

				// Reset any applied styles

				element.removeClass('js-gibe-gallery-overlay--wide');
				primary.add(secondary).add(thumbnails).add(content).add(buttons).add(mainList).removeAttr('style');

				// Available and gallery heights to be defined later

				var availableHeight, galleryHeight;

				// Assign styles for appropriate layout

				if (base.gallery.resize.wide()) {

					// Add class to define "wide" layout (this must happen before any other calculations so that the appropriate styles are present)

					element.addClass('js-gibe-gallery-overlay--wide');

					// Calculate available height

					availableHeight = base.gallery.resize.calculate.availableHeight(inner, content);

					// Calculate height available for gallery

					galleryHeight = base.gallery.resize.calculate.galleryHeight(availableHeight, title);

					// Calculate height available for thumbnails

					var thumbnailsHeight = base.gallery.resize.calculate.thumbnailsHeight(availableHeight, close);

					// Calculate secondary width

					var secondaryWidth = base.gallery.resize.calculate.secondaryWidth(thumbnailsHeight, thumbnailItems);

					// Set primary and secondary widths

					primary.css('width', 'calc(100% - ' + secondaryWidth + 'px)');
					secondary.css('width', secondaryWidth);

					// Set thumbnail height

					thumbnails.height(thumbnailsHeight);

					// If force square setting is active

					if (base.settings.forceSquare) {

						// Calculate override height

						var overrideHeight = base.gallery.resize.calculate.overrideHeight(galleryHeight, mainList, mainInner);
						galleryHeight = overrideHeight;

						// Calculate new gallery width

						var overrideWidth = base.gallery.resize.calculate.overrideWidth(galleryHeight, mainInner, secondary, content);
						content.css('max-width', overrideWidth);

						// Set thumbnail scroller height
						var thumbnailsScrollerHeight = base.gallery.resize.calculate.thumbnailScrollerHeight(overrideHeight);
						thumbnailsScroller.height(thumbnailsScrollerHeight + 'px');

						if (thumbnailsScrollerHeight === "auto") {
							$('.js-gibe-gallery-overlay__thumbnails__list__scroller').addClass('js-gibe-gallery-overlay__thumbnails__list__scroller--hide-buttons');
						}

					}

				} else {

					// Calculate available height

					availableHeight = base.gallery.resize.calculate.availableHeight(inner, content);

					// Calculate height available for gallery

					galleryHeight = base.gallery.resize.calculate.galleryHeight(availableHeight, title);

					galleryHeight -= parseInt(thumbnails.height());
					if (base.settings.forceSquare) galleryHeight = Math.min(galleryHeight, mainList.width());

					// Set max width of gallery

					content.css('max-width', base.settings.maxWidth);

					// Set width of gallery

					if (base.settings.forceSquare) mainList.width(galleryHeight);

				}

				// Set height of gallery

				main.height(galleryHeight);

				// set 360

				base.gallery.init360s();

				// Remove class denoting that resizing is ongoing

				element.removeClass('js-gibe-gallery-overlay--resizing');

			}

		},

		// Get current index

		getCurrentIndex: function () {

			var gallery = base.gallery.getElement();

			return gallery.find('.js-gibe-gallery-overlay__main__item--active').index();

		},

		getThumbnailIndex: function (thumbnailElement) {

			var index = thumbnailElement.index();

			if (thumbnailElement.closest('.js-gibe-gallery-overlay__thumbnails__list--sticky').length) {

				index = $('.js-gibe-gallery-overlay__thumbnails__list--scrollable .js-gibe-gallery-overlay__thumbnails__item').length + thumbnailElement.index();

			}

			return index;
		},

		// Transition

		transition: {

			// Whether or not to allow a transition to occur

			allow: true,

			// Get new index

			getNewIndex: function (type) {

				var itemCount = $('.js-gibe-gallery-overlay__main__item').length - 1,
					currentIndex = $('.js-gibe-gallery-overlay__main__item--active').index(),
					newIndex = 0;

				switch (type) {
					case 'prev':
						newIndex = !currentIndex ? itemCount : currentIndex - 1;
						break;
					case 'next':
						newIndex = currentIndex === itemCount ? 0 : currentIndex + 1;
						break;
					default:
				}

				return newIndex;

			},

			// Instigate transition

			go: function (index, fade) {

				if (!base.stage.transition.allow || base.gallery.getCurrentIndex() === index) return;

				if (!base.gallery.transition.allow) return;

				// Cache elements, create active class

				var element = base.gallery.getElement(),
					mainItems = element.find('.js-gibe-gallery-overlay__main__item'),
					thumbnailItems = element.find('.js-gibe-gallery-overlay__thumbnails__item'),
					mainActiveClass = 'js-gibe-gallery-overlay__main__item--active';

				// If fade transition, add additional class

				if (fade) mainActiveClass += ' js-gibe-gallery-overlay__main__item--fade';

				// If not fade transition, remove active class

				if (!fade) mainItems.removeClass('js-gibe-gallery-overlay__main__item--active');

				// If no object fit, polyfill object fit by appending image src to the container

				if (!base.settings.objectfit) {

					var currentSource = 'url(' + mainItems.eq(index).find('.js-gibe-gallery-overlay__main__image').attr('src') + ')';
					mainItems.eq(index).css('background-image', currentSource);

				}

				// Add active class

				mainItems.eq(index).addClass(mainActiveClass).attr('tabindex', 1).focus().removeAttr('tabindex');

				// Video item focussing

				var video = mainItems.eq(index).find('.js-gibe-gallery-overlay__main__video__iframe');
				if (video.length) video.focus();

				// Pause all existing vimeo videos

				$.each(base.gallery.videoInstances, function (key, value) { value.pause(); });
				$.each(base.stage.videoInstances, function (key, value) { value.pause(); });

				// If fade transition, remove previous active class + fade class after delay

				if (fade) {

					base.gallery.transition.allow = false;

					setTimeout(function () {

						mainItems.filter(':not(.js-gibe-gallery-overlay__main__item--fade)').removeClass('js-gibe-gallery-overlay__main__item--active').removeAttr('tabindex');
						mainItems.removeClass('js-gibe-gallery-overlay__main__item--fade');
						base.gallery.transition.allow = true;

					}, base.settings.fadeTime);

				}

				// Set active thumnbail states
				thumbnailItems.removeClass('js-gibe-gallery-overlay__thumbnails__item--active');
				thumbnailItems.eq(index).addClass('js-gibe-gallery-overlay__thumbnails__item--active');

				// init 360
				base.gallery.init360s();

				// reset any image zooms
				var resetImageZoomEvent = Helpers.createCustomEventForDispatch('resetImageZoom');
				document.dispatchEvent(resetImageZoomEvent);

				// Image zoom
				base.initImageZoom();

				base.gallery.setThumbnailScrollerPosition();


			}

		},

		setThumbnailScrollerPosition: function () {
			var activeThumbnail = $('.js-gibe-gallery-overlay__thumbnails__item--active');
			if (!activeThumbnail.parent().hasClass('js-gibe-gallery-overlay__thumbnails__list--scrollable')) {
				return;
			}
			var activeThumbnailTop = activeThumbnail.position().top;
			var activeThumbnailHeight = activeThumbnail.height();
			var listHeight = $('.js-gibe-gallery-overlay__thumbnails__list__scroller').height();
			var scrollInner = $('.js-gibe-gallery-overlay__thumbnails__list__scroller__inner');
			if (activeThumbnailTop + activeThumbnailHeight > listHeight) {
				var amountToMove = ((activeThumbnailTop + activeThumbnailHeight) - listHeight) + 30; // 30px padding when there are buttons
				scrollInner.css('transform', 'translateY(-' + amountToMove + 'px)');
			} else {
				scrollInner.css('transform', 'translateY(0)');
			}
		},

		// Close

		close: function () {

			var element = base.gallery.getElement();

			if (!element.length) return;

			element.addClass('js-gibe-gallery-overlay--hide');

			base.gallery.videoInstances = {};

			setTimeout(function () {

				base.gallery.lockout.off();
				element.remove();
				base.settings.forceGallery = false;

			}, base.settings.fadeTime);

		},

		// Launch

		launch: function (id) {

			// Sort gallery thumbnails so the last sticky thumbnails are Video, 360 and Tech Image
			base.items.push(base.items.splice(base.items.findIndex(function (item) { return item.IsVideo }), 1)[0]);
			base.items.push(base.items.splice(base.items.findIndex(function (item) { return item.Is360 }), 1)[0]);
			base.items.push(base.items.splice(base.items.findIndex(function (item) { return item.TechImage }), 1)[0]);

			// Render gallery
			var html = Mustache.render(base.overlayTemplate, { Items: base.items, ForceSquare: base.settings.forceSquare, ObjectFit: base.settings.objectfit, Swipe: base.settings.swipe, Title: base.title, Subtitle: base.subtitle, MultiSlide: base.settings.multiSlide });
			base.elements.body.append(html);

			// Trigger resize end

			base.gallery.resize.end();

			// Transition to appropriate index

			var indexOfSelectedItem = base.gallery.getThumbnailIndex($('.js-gibe-gallery-overlay__thumbnails__item[data-gibe-gallery-item-id="' + id + '"]'));
			base.gallery.transition.go(indexOfSelectedItem, false);

			// Assign events

			base.gallery.assignEvents();

			base.gallery.lockout.on();

			base.gallery.saveVideoReferences();

			base.initImageZoom();

		},

		saveVideoReferences: function () {

			var overlayIframe = $('.js-gibe-gallery-overlay__main__video__iframe');
			if (overlayIframe.length) {
				overlayIframe.each(function () {
					var overlayIframeId = $(this).attr('data-id');
					if (typeof base.gallery.videoInstances['video-' + overlayIframeId] === "undefined") {
						base.gallery.videoInstances['video-' + overlayIframeId] = new Vimeo.Player($(this)[0]);
					}
				});
			}

		},

		init360s: function () {

			var container360s = document.querySelectorAll('.js-gibe-gallery-360');

			for (var i = 0; i < base.threeSixtyInstances.length; i++) {
				base.threeSixtyInstances[i].destroy();
			}

			base.threeSixtyInstances = [];

			for (var i = 0; i < container360s.length; i++) {

				(function (i) {

					if (container360s[i].offsetParent !== null) {
						base.gallery.setup360(container360s[i]);
					}



				}).call(this, i);

			}

			if (container360s.length && !base.threeSixtyHasInit) {
				function keyboardOverlayCheck(e) {
					var keyPressed = base.helpers.getKeyPressed(e);
					var overlayElements = document.querySelectorAll('.js-gibe-gallery-360__overlay');
					if (keyPressed === 37 || keyPressed === 39 || keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight' || keyPressed === 'Left' || keyPressed === 'Right') {
						for (var i = 0; i < overlayElements.length; i++) {
							overlayElements[i].classList.add('is-hidden');
						}
					}
				}
				document.addEventListener('keydown', keyboardOverlayCheck);
				base.threeSixtyHasInit = true;
			}

		},


		get360Data: function (imageJSON) {

			if (base.threeSixtyCache[imageJSON]) {
				return new Promise(function (resolve, reject) {
					resolve(base.threeSixtyCache[imageJSON]);
				})
			} else {
				return fetch(imageJSON, {
					mode: 'cors',
					headers: {
						'Content-Type': 'application/json'
					}
				}).then(function (response) {
					return response.json();
				});
			}


		},

		setup360: function (currentContainer) {

			var currentParent = currentContainer.closest('.js-360-container');
			var baseProductUrl = document.querySelector('[data-product-image-base-url]').getAttribute('data-product-image-base-url');
			var base360ProductUrl = document.querySelector('[data-product-360-base-url]').getAttribute('data-product-360-base-url');
			var imageJSON = base360ProductUrl + '/' + currentContainer.getAttribute('data-360-images');
			var stageContainer = currentContainer.closest('.js-gibe-gallery-stage__360');

			stageContainer.classList.add('is-loading');

			base.gallery.get360Data(imageJSON)
				.then(function (data) {

					base.threeSixtyCache[imageJSON] = data;

					var images = data.map(function (image) {
						return baseProductUrl + '/' + image;
					});

					var threesixty = new ThreeSixty(currentContainer, {
						image: images,
						width: currentParent.clientWidth,
						height: currentParent.clientHeight,
						speed: 100,
						dragTolerance: 5
					});

					base.threeSixtyInstances.push(threesixty);


					Promise.all(images.map(Helpers.preloadImage))
						.then(function () {
							stageContainer.classList.remove('is-loading');
						}).catch(function () {
							stageContainer.classList.remove('is-loading');
						});

					var container360Stage = currentContainer.closest('.js-gibe-gallery-stage__360');
					var overlayElement = container360Stage.querySelector('.js-gibe-gallery-360__overlay');

					container360Stage.addEventListener('click', function () {
						if (overlayElement) {
							overlayElement.classList.add('is-hidden');
						}
					});

					var mouseDown = false;
					var draggingCSSClass = 'is-dragging-360';
					var hiddenCSSClass = 'is-hidden';
					var usingTouch = false;

					container360Stage.addEventListener('mouseenter', function () {
						if (overlayElement && !usingTouch) {
							setTimeout(function () { overlayElement.classList.add(hiddenCSSClass); }, 1000);
							document.body.classList.add(draggingCSSClass);

							function handleMouseUp() {
								document.body.classList.remove(draggingCSSClass);
								mouseDown = false;
								document.removeEventListener('mouseup', handleMouseUp);
							}

							document.addEventListener('mouseup', handleMouseUp);
						}
					});

					container360Stage.addEventListener('mousedown', function () {
						mouseDown = true;
					});

					container360Stage.addEventListener('mouseleave', function () {
						if (overlayElement && !mouseDown) {
							document.body.classList.remove(draggingCSSClass);
						}
					});

					container360Stage.addEventListener('touchstart', function () {
						usingTouch = true;
						if (overlayElement) {
							overlayElement.classList.add(hiddenCSSClass);
						}
					});

					container360Stage.addEventListener('touchend', function () {
						usingTouch = false;
					});

				})
				.catch(function (error) {
					console.log(error);
					popups.confirm('Error', 'Sorry, there was a problem loading the 360 for this product. Please try again later.', '', true);
				});
		},

		// Assign events

		assignEvents: function () {

			// Get and cache gallery

			var gallery = base.gallery.getElement();

			// Cache items

			var prev = gallery.find('.js-gibe-gallery-overlay__main__button--previous'),
				next = gallery.find('.js-gibe-gallery-overlay__main__button--next'),
				prevThumbnail = gallery.find('.js-gibe-gallery-overlay__thumbnails__list__scroller__button--previous'),
				nextThumbnail = gallery.find('.js-gibe-gallery-overlay__thumbnails__list__scroller__button--next'),
				itemButtons = gallery.find('.js-gibe-gallery-overlay__thumbnails__item-button'),
				close = gallery.find('.js-gibe-gallery-overlay__close__button'),
				dimmer = gallery.find('.js-gibe-gallery-overlay__dimmer');

			// Previous click

			prev.on('click keypress', function (e) {

				var newIndex = base.gallery.transition.getNewIndex('prev');
				base.gallery.transition.go(newIndex, true);

				e.stopPropagation();

			});

			// Next click

			next.on('click keypress', function (e) {

				var newIndex = base.gallery.transition.getNewIndex('next');
				base.gallery.transition.go(newIndex, true);

				e.stopPropagation();

			});

			// Previous thumbnail click

			prevThumbnail.on('click keypress', function (e) {

				var newIndex = base.gallery.transition.getNewIndex('prev');
				base.gallery.transition.go(newIndex, true);

				e.stopPropagation();

			});

			// Next thumbnail click

			nextThumbnail.on('click keypress', function (e) {

				var newIndex = base.gallery.transition.getNewIndex('next');
				base.gallery.transition.go(newIndex, true);

				e.stopPropagation();

			});

			// Items click

			itemButtons.on('click', function () {

				var newIndex = base.gallery.getThumbnailIndex($(this).parent());

				base.gallery.transition.go(newIndex, true);

				return false;

			});

			// Dimmer click

			dimmer.on('click', function () { base.gallery.close(); });

			// Close click

			close.on('click', function () { base.gallery.close(); });

			// Close keydown - ensure focus styles are present and focus on active zoom element

			close.on('keydown', function (e) {

				var keyPressed = base.helpers.getKeyPressed(e);

				if (keyPressed === 13 || keyPressed === 'Enter') {

					setTimeout(function () {

						base.focusStyles.on();
						base.elements.stage.find('.js-gibe-gallery-stage__item--active .js-gibe-gallery-stage__item__zoom').focus();

					}, 1000);

				}

			});

			// Check if touch swipe library is present and add swipe events
			if (base.settings.swipe) {

				var gesture = new TinyGesture(gallery.find('.js-gibe-gallery-overlay__main__list')[0], base.tinyGestureOptions);

				gesture.on('swipeleft', function (event) {
					if ($('.js-gibe-gallery-overlay__main__item--active').hasClass('js-360-container') || $('html').hasClass('image-zoom-active')) {
						return;
					}
					newIndex = base.gallery.transition.getNewIndex('next');
					base.gallery.transition.go(newIndex, true);
				});

				gesture.on('swiperight', function (event) {
					if ($('.js-gibe-gallery-overlay__main__item--active').hasClass('js-360-container') || $('html').hasClass('image-zoom-active')) {
						return;
					}
					newIndex = base.gallery.transition.getNewIndex('prev');
					base.gallery.transition.go(newIndex, true);
				});

			}

			// Add preloading on mouse enter

			gallery.find('.js-gibe-gallery-overlay__thumbnails__item').mouseenter(function () {

				var target = $(this);
				if (target.data('preloaded')) return;

				var timer = setTimeout(function () {

					if (base.elements.stage.find('.js-gibe-gallery-overlay__main__item').eq(target.data('index')).find('img').length) {
						var imageToLoad = base.elements.stage.find('.js-gibe-gallery-overlay__main__item').eq(target.data('index')).find('img');
						imageToLoad.attr('loading', 'eager');
					}

					if (target.attr('data-gibe-gallery-item') === 'video') {
						var videoID = target.attr('data-gibe-gallery-item-id');
						var videoIframe = base.elements.stage.find('.js-gibe-gallery-overlay__main__video__iframe[data-id="' + videoID + '"]');
						videoIframe.attr('loading', 'eager');
					}

					target.data('preloaded', true);

				}, base.settings.hoverTime);

				target.data('hoverTimer', timer);

			}).on('mouseleave', function () {

				var target = $(this);
				if (target.data('preloaded')) return;

				clearTimeout(target.data('hoverTimer'));

			});

			// Add object fit polyfill

			if (!base.settings.objectfit) {

				$('.js-gibe-gallery-overlay__main__image').each(function () {

					var currentSource = 'url(' + $(this).attr('src') + ')';
					$(this).closest('.js-gibe-gallery-overlay__main__item').css('background-image', currentSource);

				});

			}

			// Trap focus inside the overlay

			itemButtons.last().focusout(function () { $('.js-gibe-gallery-overlay__main__item--active').focus(); });

		}

	};

	// STAGE
	// The in-page slideshow used on smaller screens

	base.stage = {

		// Video instances

		videoInstances: {},

		// Resize

		resize: {

			end: function () {

				if (base.gallery.allow()) {

					base.elements.stageElement.addClass('js-gibe-gallery-stage--gallery-active');

				} else {

					base.elements.stageElement.removeClass('js-gibe-gallery-stage--gallery-active');

				}
			}

		},

		// Render

		render: function () {

			// Cache stage element that was injected

			base.elements.stageElement = base.elements.stage.find('.js-gibe-gallery-stage');

			if (!base.settings.objectfit) {
				base.elements.stageElement.removeClass('js-gibe-gallery-stage--objectfit"');
			}

			// assign events

			base.stage.assignEvents();

			// Resize

			base.stage.resize.end();

			// Add loaded class to show elements that might be toggled based on environment (left and right arrows etc)

			base.elements.stage.addClass('js-gibe-gallery-stage--loaded');

			// save any video instances
			base.stage.saveVideoReferences();

			base.initImageZoom();

			// Quicklinks setup

			base.stage.quicklinks.init();

			// Set initial button display

			base.stage.setButtonVisibility(base.stage.getCurrentIndex());

			// Thumbnail arrows

			base.stage.thumbnails.checkArrowDisplay(); 

		},

		saveVideoReferences: function () {
			var stageIframe = base.element.find('.js-gibe-gallery-stage__video__iframe');
			if (stageIframe.length && typeof Vimeo !== "undefined") {
				stageIframe.each(function () {
					var stageIframeId = $(this).attr('data-id');
					if (typeof base.stage.videoInstances['video-' + stageIframeId] === "undefined") { base.stage.videoInstances['video-' + stageIframeId] = new Vimeo.Player($(this)[0]); }
				});
			}
		},

		// Assign events

		assignEvents: function () {

			// Click on button to open the overlay

			base.elements.stage.find('.js-gibe-gallery-open-overlay').on('click', function (e) {

				if (base.gallery.allow()) {

					var currentId = base.stage.getCurrentId();
					base.gallery.launch(currentId);

				}

			});

			// Key down to open overlay

			base.elements.stage.find('.js-gibe-gallery-open-overlay').on('keydown', function (e) {

				// If enter key pressed force the gallery for all screen sizes

				var keyPressed = base.helpers.getKeyPressed(e);

				if (keyPressed === 13 || keyPressed === 'Enter') {

					base.settings.forceGallery = true;

					if (base.gallery.allow()) {

						var currentId = base.stage.getCurrentId();
						base.gallery.launch(currentId);

					}

				}

			});

			// Previous buttons

			var previousButtons = base.elements.stage.find('.js-gibe-gallery-stage__item__arrow--previous');
			previousButtons.on('click', function (e) {

				var nextItemIndex = base.stage.transition.getNewIndex('prev');
				base.stage.transition.go(nextItemIndex);
				return false;

			});

			// Next button

			var nextButtons = base.elements.stage.find('.js-gibe-gallery-stage__item__arrow--next');
			nextButtons.on('click', function (e) {

				var nextItemIndex = base.stage.transition.getNewIndex('next');
				base.stage.transition.go(nextItemIndex);
				return false;

			});

			// Thumbnail previous buttons

			var previousThumbnailButton = base.element.find('.js-gibe-gallery-previous');
			previousThumbnailButton.on('click', function (e) {
				base.stage.thumbnails.moveThumbnails('previous');
				return false;
			});

			// Thumbnail Next button

			var nextThumbnailButton = base.element.find('.js-gibe-gallery-next');
			nextThumbnailButton.on('click', function (e) {
				base.stage.thumbnails.moveThumbnails('next');
				return false;
			});

			if (base.settings.transition === "slide") {

				// When the user free scrolls the gallery, update the active item

				const galleryList = base.elements.stage.find('.js-gibe-gallery-stage__list')[0];
				const galleryItems = galleryList.querySelectorAll('.js-gibe-gallery-stage__item');

				let mostVisibleItem = null;

				const observer = new IntersectionObserver((entries) => {
					let maxVisibleArea = 0;
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							const visibleArea = entry.intersectionRect.width * entry.intersectionRect.height;
							if (visibleArea > maxVisibleArea) {
								maxVisibleArea = visibleArea;
								mostVisibleItem = entry.target;
							}
						}
					});
				}, {
					root: galleryList,
					threshold: 0.5
				});

				galleryItems.forEach(item => observer.observe(item));

				function getMostVisibleItem() {
					return mostVisibleItem;
				}

				function updateActiveItem() {
					if (base.userIsUsingButtons) {
						return;
					}
					const mostVisibleItem = getMostVisibleItem();
					if (mostVisibleItem) {
						const index = Array.from(galleryItems).indexOf(mostVisibleItem);
						base.stage.transition.go(index);
					}
				}

				// Hide zoom buttons when scrolling

				const buttonsOverImage = document.querySelectorAll('.js-image-zoom-button, .js-gibe-gallery-open-overlay');
				let isScrolling;

				galleryList.addEventListener('scroll', () => {

					buttonsOverImage.forEach(button => {
						button.setAttribute('aria-hidden', 'true');
					});

					clearTimeout(isScrolling);

					// Set a timeout to run after scrolling ends
					isScrolling = setTimeout(() => {
						buttonsOverImage.forEach(button => {
							button.setAttribute('aria-hidden', 'false');
						});
						updateActiveItem();
					}, 100);

				});

				// Check thumbnail display when scrolling
				const debouncedCheckThumbnailArrowDisplay = Helpers.debounce(()=> base.stage.thumbnails.checkArrowDisplay(), 100);
				const thumbnailGalleryList = base.element.find('.c-gallery__list')[0];
				thumbnailGalleryList.addEventListener('scroll', debouncedCheckThumbnailArrowDisplay);
		
			}

			// Reveal buttons over the image on devices that support touch

			if (base.settings.touch) {

				base.elements.stage.find('.js-gibe-gallery-stage__item').on('touchstart', function (e) {
					base.elements.stageElement.addClass('js-gibe-gallery-controls-active');
				});

				// Clicking outside of the gallery hides the controls

				base.elements.doc.on('touchstart', function () {
					base.elements.stageElement.removeClass('js-gibe-gallery-controls-active');
				});

			}

			if (base.settings.swipe && base.settings.transition !== "slide") {

				var gesture = new TinyGesture(base.elements.stage.find('.js-gibe-gallery-stage__list')[0], base.tinyGestureOptions);

				gesture.on('swipeleft', function (event) {
					if (base.elements.stage.find('.js-gibe-gallery-stage__item--active').find('.js-gibe-gallery-stage__360').length || $('html').hasClass('image-zoom-active')) {
						return;
					}
					newIndex = base.stage.transition.getNewIndex('next');
					base.stage.transition.go(newIndex);
				});

				gesture.on('swiperight', function (event) {
					if (base.elements.stage.find('.js-gibe-gallery-stage__item--active').find('.js-gibe-gallery-stage__360').length || $('html').hasClass('image-zoom-active')) {
						return;
					}
					newIndex = base.stage.transition.getNewIndex('prev');
					base.stage.transition.go(newIndex);
				});

			}

			// Add preloading on mouse enter

			base.elements.links.mouseenter(function () {

				var target = $(this);
				if (target.data('preloaded')) return;

				var timer = setTimeout(function () {

					if (base.elements.stage.find('.js-gibe-gallery-stage__item').eq(target.data('index')).find('img').length) {
						var imageToLoad = base.elements.stage.find('.js-gibe-gallery-stage__item').eq(target.data('index')).find('img');
						imageToLoad.attr('loading', 'eager');
					}

					if (target.attr('data-gibe-gallery-item') === 'video') {
						var videoID = target.attr('data-gibe-gallery-item-id');
						var videoIframe = base.elements.stage.find('.js-gibe-gallery-stage__video__iframe[data-id="' + videoID + '"]');
						videoIframe.attr('loading', 'eager');
					}

					target.data('preloaded', true);

				}, base.settings.hoverTime);

				target.data('hoverTimer', timer);

			}).on('mouseleave', function () {

				var target = $(this);
				if (target.data('preloaded')) return;

				clearTimeout(target.data('hoverTimer'));

			});

			// Add object fit polyfill

			if (!base.settings.objectfit) {

				$('.js-gibe-gallery-stage__image').each(function () {

					var currentSource = 'url(' + $(this).attr('src') + ')';
					$(this).closest('.js-gibe-gallery-stage__item').css('background-image', currentSource);

				});

			}

		},

		setButtonVisibility: function (currentIndex) {

			if (base.settings.transition !== "slide") {
				return;
			}

			const items = base.elements.stage.find('.js-gibe-gallery-stage__item');

			if (currentIndex === 0) {
				base.elements.stage.find('.js-gibe-gallery-stage__item__arrow--previous').attr('aria-hidden', 'true');
			} else {
				base.elements.stage.find('.js-gibe-gallery-stage__item__arrow--previous').attr('aria-hidden', 'false');
			}

			if (currentIndex === items.length - 1) {
				base.elements.stage.find('.js-gibe-gallery-stage__item__arrow--next').attr('aria-hidden', 'true');
			} else {
				base.elements.stage.find('.js-gibe-gallery-stage__item__arrow--next').attr('aria-hidden', 'false');
			}

		},

		// Get current index

		getCurrentIndex: function () {

			return base.elements.stage.find('.js-gibe-gallery-stage__item--active').index();

		},

		// Get current id

		getCurrentId: function () {

			return base.elements.links.filter(".c-gallery__link--active").attr('data-gibe-gallery-item-id') || $(".c-gallery__link--active").attr('data-gibe-gallery-item-id');

		},

		// Quicklinks

		quicklinks: {

			init: function () {
				if (!base.stage.quicklinks.areAvailable()) {
					return;
				}
				base.stage.quicklinks.checkIfCustomerPhotosShouldDisplay();
				if (!base.element.find('.js-gibe-gallery-quicklinks-item:visible').length) {
					base.element.find('.js-gibe-gallery-quicklinks').hide();
				}

			},

			areAvailable: function () {
				return base.element.find('.js-gibe-gallery-quicklinks').length;
			},

			checkIfCustomerPhotosShouldDisplay: function () {
				if (!$('#product-customer-images').length) {
					base.element.find('.js-gibe-gallery-quicklink-customer-photos').hide();
				}
			}

		},

		// Thumbnails

		thumbnails: {

			hasThumbnailScroller: function () {
				return base.element.find('.js-gibe-gallery-previous') || base.element.find('.js-gibe-gallery-next') || base.settings.transition === "slide";
			},

			scrollToThumbnail: function (thumbnail) {

				const container = thumbnail.closest('.c-gallery__list');
				const containerRect = container.getBoundingClientRect();
				const thumbnailRect = thumbnail.getBoundingClientRect();

				if (thumbnailRect.left === 0 && containerRect.left === 0) {
					return;
				}

				const containerCenter = containerRect.left + containerRect.width / 2;
				const thumbnailCenter = thumbnailRect.left + thumbnailRect.width / 2;
				const offset = thumbnailCenter - containerCenter;

				container.scrollLeft += offset;

			},

			checkArrowDisplay: function () {

				const itemsContainer = base.element.find('.c-gallery__list')[0];
				const lastItem = base.element.find('.c-gallery__item').last()[0];
				const itemsContainerRect = itemsContainer.getBoundingClientRect();
				const lastItemRect = lastItem.getBoundingClientRect();
				const proxitmityThreshold = 11;

				if ((lastItemRect.right + proxitmityThreshold) < itemsContainerRect.right) {
					base.element.find('.js-gibe-gallery-previous').attr('aria-hidden', 'true');
					base.element.find('.js-gibe-gallery-next').attr('aria-hidden', 'true');
					return;
				}

				if ((itemsContainer.scrollWidth - itemsContainer.scrollLeft - itemsContainer.clientWidth) < proxitmityThreshold) {
					base.element.find('.js-gibe-gallery-previous').attr('aria-hidden', 'false');
					base.element.find('.js-gibe-gallery-next').attr('aria-hidden', 'true');
					return;
				}

				if (itemsContainer.scrollLeft <= proxitmityThreshold) {
					base.element.find('.js-gibe-gallery-previous').attr('aria-hidden', 'true');
					base.element.find('.js-gibe-gallery-next').attr('aria-hidden', 'false');
					return;
				}

				base.element.find('.js-gibe-gallery-previous').attr('aria-hidden', 'false');
				base.element.find('.js-gibe-gallery-next').attr('aria-hidden', 'false');

			},

			moveThumbnails: function (direction) {

				const itemsContainer = base.element.find('.c-gallery__list')[0];
				const lastItem = base.element.find('.c-gallery__item').last()[0];
				const itemsContainerRect = itemsContainer.getBoundingClientRect();
				const lastItemRect = lastItem.getBoundingClientRect();
				const outerContainerWidth = base.element.find('.c-gallery__items-container').width();

				// if direction next, move right
				if (direction === "next") {
					itemsContainer.scrollLeft += outerContainerWidth;
				}

				// if direction previous, move left
				if (direction === "previous") {
					itemsContainer.scrollLeft -= outerContainerWidth;
				}

			}

		},

		// Transition

		transition: {

			// Whether or not to allow a transition to occur

			allow: true,

			// Get new index

			getNewIndex: function (type) {

				var itemCount = base.elements.stage.find('.js-gibe-gallery-stage__item').length - 1,
					currentIndex = base.elements.stage.find('.js-gibe-gallery-stage__item--active').index(),
					newIndex = 0;

				switch (type.toLowerCase()) {
					case 'prev':
						newIndex = !currentIndex ? itemCount : currentIndex - 1;
						break;
					case 'next':
						newIndex = currentIndex === itemCount ? 0 : currentIndex + 1;
						break;
					default:
				}

				return newIndex;

			},

			// Instigate transition

			go: function (index) {

				if (!base.stage.transition.allow || base.stage.getCurrentIndex() === index) return;

				// Cache elements, create active class

				var items = base.elements.stage.find('.js-gibe-gallery-stage__item'),
					itemToGoTo = items.eq(index),
					itemActiveclass = 'js-gibe-gallery-stage__item--active js-gibe-gallery-stage__item--fade';

				// If no object fit, polyfill object fit by appending image src to the container

				if (!base.settings.objectfit) {

					var currentSource = 'url(' + itemToGoTo.find('.js-gibe-gallery-stage__image').attr('src') + ')';
					items.eq(index).css('background-image', currentSource);

				}

				// Add active class

				itemToGoTo.addClass(itemActiveclass).attr('tabindex', '1');
				itemToGoTo.attr('data-test', 'active-gallery-item');

				// Pause all existing vimeo videos

				$.each(base.stage.videoInstances, function (key, value) { value.pause(); });

				// Remove previous active class + fade class after delay

				base.stage.transition.allow = false;

				setTimeout(function () {
					items.not(itemToGoTo).removeClass('js-gibe-gallery-stage__item--active').removeAttr('tabindex').removeAttr('data-test');
					items.removeClass('js-gibe-gallery-stage__item--fade');
					base.stage.transition.allow = true;

				}, base.settings.fadeTime);

				// Scroll to active gallery item

				var activeGalleryItem = itemToGoTo[0];
				var activeGalleryItemPosition = activeGalleryItem.getBoundingClientRect();
				var galleryList = base.elements.stage.find('.js-gibe-gallery-stage__list')[0];
				var galleryListPosition = galleryList.getBoundingClientRect();
				galleryList.scrollLeft = activeGalleryItemPosition.left - galleryListPosition.left + galleryList.scrollLeft;

				base.stage.watchScrollLeftUntilStable(galleryList, () => {
					if ($('.js-gibe-gallery-stage__item--active').hasClass('js-360-container') || $('html').hasClass('image-zoom-active')) {
						$('.js-gibe-gallery-stage__list').addClass('stop-scrolling');
					} else {
						$('.js-gibe-gallery-stage__list').removeClass('stop-scrolling');
					}
				}, 250, 3000);

				// Check button display

				base.stage.setButtonVisibility(index);

				// Remove / add class to appropriate inline thumbnail link

				base.elements.links.removeClass(base.settings.linksActiveClass);

				base.elements.links.each(function () {
					if ($(this).data('index') === index) {
						$(this).addClass(base.settings.linksActiveClass);
						if (base.stage.thumbnails.hasThumbnailScroller()) {
							base.stage.thumbnails.scrollToThumbnail($(this)[0]);
							//setTimeout(() => {
							//	base.stage.thumbnails.checkArrowDisplay();
							//}, 500);
						}
					}
				});

				// 360
				base.gallery.init360s();

				// image zoom
				base.initImageZoom();

				// Callback

				base.settings.onStageChange.call(base, index);

				// reset any image zooms

				var resetImageZoomEvent = Helpers.createCustomEventForDispatch('resetImageZoom');
				document.dispatchEvent(resetImageZoomEvent);

			}

		},

		// Launch

		launch: function (index) {

			// Get current page scroll
			//var currentPageScroll = window.scrollY;

			// Go to specified index

			base.stage.transition.go(index);

			// Scroll to top of stage if appropriate
			if (!base.stage.thumbnails.hasThumbnailScroller()) {
				var stageTop = base.elements.stage.offset().top;
				if (base.elements.win.scrollTop() > stageTop) base.elements.html.add(base.elements.body).animate({ scrollTop: stageTop }, 250);
			}
			//else {
			//	window.scrollY = currentPageScroll;
			//}

			//console.log('scroll', currentPageScroll);

		},

		watchScrollLeftUntilStable: function(galleryList, callback, interval, timeout) {
			let lastScrollLeft = galleryList.scrollLeft;
			let stableCount = 0;
			const maxStableCount = 3; // Number of consecutive checks with no change to consider stable

			const checkScrollLeft = () => {
				const currentScrollLeft = galleryList.scrollLeft;
				if (currentScrollLeft === lastScrollLeft) {
					stableCount++;
					if (stableCount >= maxStableCount) {
						clearInterval(scrollCheckInterval);
						if (callback) callback();
					}
				} else {
					stableCount = 0;
					lastScrollLeft = currentScrollLeft;
				}
			};

			const scrollCheckInterval = setInterval(checkScrollLeft, interval);

			setTimeout(() => {
				clearInterval(scrollCheckInterval);
			}, timeout);
		}

	};

	base.stage.render();

	// Return the jQuery object

	return base;

};

// https://github.com/mladenilic/threesixty.js
!function (e, t) { "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.ThreeSixty = t() : e.ThreeSixty = t() }(window, (function () { return function (e) { var t = {}; function n(i) { if (t[i]) return t[i].exports; var o = t[i] = { i: i, l: !1, exports: {} }; return e[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports } return n.m = e, n.c = t, n.d = function (e, t, i) { n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: i }) }, n.r = function (e) { "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 }) }, n.t = function (e, t) { if (1 & t && (e = n(e)), 8 & t) return e; if (4 & t && "object" == typeof e && e && e.__esModule) return e; var i = Object.create(null); if (n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var o in e) n.d(i, o, function (t) { return e[t] }.bind(null, o)); return i }, n.n = function (e) { var t = e && e.__esModule ? function () { return e.default } : function () { return e }; return n.d(t, "a", t), t }, n.o = function (e, t) { return Object.prototype.hasOwnProperty.call(e, t) }, n.p = "", n(n.s = 2) }([function (e, t) { var n; n = function () { return this }(); try { n = n || new Function("return this")() } catch (e) { "object" == typeof window && (n = window) } e.exports = n }, function (e, t, n) { "use strict"; (function (e) { function n(e, t) { for (var n = 0; n < t.length; n++) { var i = t[n]; i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i) } } function i(e, t) { var n = t.get(e); if (!n) throw new TypeError("attempted to get private field on non-instance"); return n.get ? n.get.call(e) : n.value } function o(e, t, n) { var i = t.get(e); if (!i) throw new TypeError("attempted to set private field on non-instance"); if (i.set) i.set.call(e, n); else { if (!i.writable) throw new TypeError("attempted to set read only private field"); i.value = n } return n } var s = function () { function t(e, n) { var s = this; !function (e, t) { if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function") }(this, t), r.set(this, { writable: !0, value: null }), a.set(this, { writable: !0, value: null }), u.set(this, { writable: !0, value: null }), o(this, a, n), o(this, u, { container: { mousedown: function (e) { return o(s, r, e.pageX) }, touchstart: function (e) { return o(s, r, e.touches[0].clientX) }, touchend: function () { return o(s, r, null) } }, prev: { mousedown: function (t) { t.preventDefault(), e.play(!0) }, mouseup: function (t) { t.preventDefault(), e.stop() }, touchstart: function (t) { t.preventDefault(), e.prev() } }, next: { mousedown: function (t) { t.preventDefault(), e.play() }, mouseup: function (t) { t.preventDefault(), e.stop() }, touchstart: function (t) { t.preventDefault(), e.next() } }, global: { mouseup: function () { return o(s, r, null) }, mousemove: function (t) { i(s, r) && Math.abs(i(s, r) - t.pageX) > i(s, a).dragTolerance && (e.stop(), i(s, r) > t.pageX ? e.prev() : e.next(), o(s, r, t.pageX)) }, touchmove: function (t) { i(s, r) && Math.abs(i(s, r) - t.touches[0].clientX) > i(s, a).swipeTolerance && (e.stop(), i(s, r) > t.touches[0].clientX ? e.prev() : e.next(), o(s, r, t.touches[0].clientX)) }, keydown: function (t) { [37, 39].includes(t.keyCode) && e.play(37 === t.keyCode) }, keyup: function (t) { [37, 39].includes(t.keyCode) && e.stop() } } }), this._initEvents() } var s, h, c; return s = t, (h = [{ key: "destroy", value: function () { i(this, a).swipeTarget.removeEventListener("mousedown", i(this, u).container.mousedown), i(this, a).swipeTarget.removeEventListener("touchstart", i(this, u).container.touchstart), i(this, a).swipeTarget.removeEventListener("touchend", i(this, u).container.touchend), e.removeEventListener("mouseup", i(this, u).global.mouseup), e.removeEventListener("mousemove", i(this, u).global.mousemove), e.removeEventListener("touchmove", i(this, u).global.touchmove), e.removeEventListener("keydown", i(this, u).global.keydown), e.removeEventListener("keyup", i(this, u).global.keyup), i(this, a).prev && (i(this, a).prev.removeEventListener("mousedown", i(this, u).prev.mousedown), i(this, a).prev.removeEventListener("mouseup", i(this, u).prev.mouseup), i(this, a).prev.removeEventListener("touchstart", i(this, u).prev.touchstart)), i(this, a).next && (i(this, a).next.removeEventListener("mousedown", i(this, u).next.mousedown), i(this, a).next.removeEventListener("mouseup", i(this, u).next.mouseup), i(this, a).next.removeEventListener("touchstart", i(this, u).next.touchstart)) } }, { key: "_initEvents", value: function () { i(this, a).draggable && (i(this, a).swipeTarget.addEventListener("mousedown", i(this, u).container.mousedown), e.addEventListener("mouseup", i(this, u).global.mouseup), e.addEventListener("mousemove", i(this, u).global.mousemove)), i(this, a).swipeable && (i(this, a).swipeTarget.addEventListener("touchstart", i(this, u).container.touchstart), i(this, a).swipeTarget.addEventListener("touchend", i(this, u).container.touchend), e.addEventListener("touchmove", i(this, u).global.touchmove)), i(this, a).keys && (e.addEventListener("keydown", i(this, u).global.keydown), e.addEventListener("keyup", i(this, u).global.keyup)), i(this, a).prev && (i(this, a).prev.addEventListener("mousedown", i(this, u).prev.mousedown), i(this, a).prev.addEventListener("mouseup", i(this, u).prev.mouseup), i(this, a).prev.addEventListener("touchstart", i(this, u).prev.touchstart)), i(this, a).next && (i(this, a).next.addEventListener("mousedown", i(this, u).next.mousedown), i(this, a).next.addEventListener("mouseup", i(this, u).next.mouseup), i(this, a).next.addEventListener("touchstart", i(this, u).next.touchstart)) } }]) && n(s.prototype, h), c && n(s, c), t }(), r = new WeakMap, a = new WeakMap, u = new WeakMap; t.a = s }).call(this, n(0)) }, function (e, t, n) { "use strict"; n.r(t), function (e) { var i = n(1); function o(e, t) { for (var n = 0; n < t.length; n++) { var i = t[n]; i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i) } } function s(e, t) { var n = t.get(e); if (!n) throw new TypeError("attempted to get private field on non-instance"); return n.get ? n.get.call(e) : n.value } function r(e, t, n) { var i = t.get(e); if (!i) throw new TypeError("attempted to set private field on non-instance"); if (i.set) i.set.call(e, n); else { if (!i.writable) throw new TypeError("attempted to set read only private field"); i.value = n } return n } var a = function () { function t(e, n) { !function (e, t) { if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function") }(this, t), u.set(this, { writable: !0, value: null }), h.set(this, { writable: !0, value: 0 }), c.set(this, { writable: !0, value: null }), l.set(this, { writable: !0, value: !1 }), p.set(this, { writable: !0, value: null }), v.set(this, { writable: !0, value: !1 }), this.container = e, r(this, u, Object.assign({ width: 300, height: 300, aspectRatio: 0, count: 0, perRow: 0, speed: 100, dragTolerance: 10, swipeTolerance: 10, draggable: !0, swipeable: !0, keys: !0, inverted: !1 }, n)), s(this, u).swipeTarget = s(this, u).swipeTarget || this.container, r(this, v, !Array.isArray(s(this, u).image)), this.sprite || (s(this, u).count = s(this, u).image.length), Object.freeze(s(this, u)), r(this, p, new i.a(this, s(this, u))), this._windowResizeListener = this._windowResizeListener.bind(this), this._initContainer() } var n, a, d; return n = t, (a = [{ key: "next", value: function () { this.goto(s(this, u).inverted ? s(this, h) - 1 : s(this, h) + 1) } }, { key: "prev", value: function () { this.goto(s(this, u).inverted ? s(this, h) + 1 : s(this, h) - 1) } }, { key: "goto", value: function (e) { r(this, h, (s(this, u).count + e) % s(this, u).count), this._update() } }, { key: "play", value: function (e) { this.looping || (this._loop(e), r(this, l, !0)) } }, { key: "stop", value: function () { this.looping && (e.clearTimeout(s(this, c)), r(this, l, !1)) } }, { key: "toggle", value: function (e) { this.looping ? this.stop() : this.play(e) } }, { key: "destroy", value: function () { this.stop(), s(this, p).destroy(), this.container.style.width = "", this.container.style.height = "", this.container.style.backgroundImage = "", this.container.style.backgroundPositionX = "", this.container.style.backgroundPositionY = "", this.container.style.backgroundSize = "", this.isResponsive && window.removeEventListener("resize", this._windowResizeListener) } }, { key: "_loop", value: function (t) { var n = this; t ? this.prev() : this.next(), r(this, c, e.setTimeout((function () { n._loop(t) }), s(this, u).speed)) } }, { key: "_update", value: function () { this.sprite ? (this.container.style.backgroundPositionX = -s(this, h) % s(this, u).perRow * this.containerWidth + "px", this.container.style.backgroundPositionY = -Math.floor(s(this, h) / s(this, u).perRow) * this.containerHeight + "px") : this.container.style.backgroundImage = 'url("'.concat(s(this, u).image[s(this, h)], '")') } }, { key: "_windowResizeListener", value: function () { this.container.style.height = this.containerHeight + "px", this._update() } }, { key: "_initContainer", value: function () { if (this.isResponsive || (this.container.style.width = this.containerWidth + "px"), this.container.style.height = this.containerHeight + "px", this.sprite) { this.container.style.backgroundImage = 'url("'.concat(s(this, u).image, '")'); var e = s(this, u).perRow, t = Math.ceil(s(this, u).count / s(this, u).perRow); this.container.style.backgroundSize = 100 * e + "% " + 100 * t + "%" } this.isResponsive && window.addEventListener("resize", this._windowResizeListener), this._update() } }, { key: "isResponsive", get: function () { return s(this, u).aspectRatio > 0 } }, { key: "containerWidth", get: function () { return this.isResponsive ? this.container.clientWidth : s(this, u).width } }, { key: "containerHeight", get: function () { return this.isResponsive ? this.container.clientWidth * s(this, u).aspectRatio : s(this, u).height } }, { key: "index", get: function () { return s(this, h) } }, { key: "looping", get: function () { return s(this, l) } }, { key: "sprite", get: function () { return s(this, v) } }]) && o(n.prototype, a), d && o(n, d), t }(), u = new WeakMap, h = new WeakMap, c = new WeakMap, l = new WeakMap, p = new WeakMap, v = new WeakMap; t.default = a }.call(this, n(0)) }]).default }));

